const Houses = [
  {
    id: 1,
    name: 'Saviesa-Home',
    image: './Images/House-1.jpg',
  },
  {
    id: 2,
    name: 'Aondowase-Homes',
    image: './Images/House-2.jpg',
  },
  {
    id: 3,
    name: 'Orban-Homes',
    image: './Images/House-3.jpg',
  },
  {
    id: 4,
    name: 'James-Homes',
    image: './Images/House-4.jpg',
  },
  {
    id: 5,
    name: 'Lilly-Homes',
    image: './Images/House-5.jpg',
  },
  {
    id: 6,
    name: 'Efab-Estate',
    image: './Images/House-6.jpg',
  },
  {
    id: 7,
    name: 'Ipent-2 Estate',
    image: './Images/House-7.jpg',
  },
  {
    id: 8,
    name: 'Villa Suites',
    image: './Images/House-8.jpg',
  },
  {
    id: 9,
    name: 'Emese Pop',
    image: './Images/House-9.jpg',
  },
  {
    id: 10,
    name: 'Francesco-Ungro',
    image: './Images/House-10.jpg',
  },
  {
    id: 11,
    name: 'Jessica-Bryant',
    image: './Images/House-11.jpg',
  },
]

export default Houses
